import { Dialog as UnifiedDialog } from '@oneaudi/unified-web-components';
import { DialogBaseProps } from 'node_modules/@oneaudi/unified-web-components/dist/esm/components/dialog';
import React from 'react';
import { StyledDialogContent } from '~/components/dialog/styles/styled-dialog';
import { FootnoteRenderer } from '~/components/footnotes';
import { FootnoteProvider } from '~/components/footnotes/footnote-context';

type FocusDialogProps = DialogBaseProps & {
	variant: 'focus-large' | 'focus-small';
	onCloseButtonAriaLabel: string;
};

type AlertDialogProps = DialogBaseProps & {
	variant: 'alert';
};

export const Dialog = ({
	children,
	classNameDialog,
	onCloseButtonClick,
	classNameContent,
	open,
	variant = 'focus-large',
	triggerElement,
}: {
	children: React.ReactNode;
	classNameDialog?: string;
	classNameContent?: string;
	onCloseButtonClick?: () => void;
	open: boolean;
	variant?: 'focus-large' | 'focus-small' | 'alert';
	triggerElement?: React.ReactNode;
}) => {
	const commonProps: DialogBaseProps = {
		open,
		children,
		className: classNameDialog,
		onClose: onCloseButtonClick,
		triggerButton: triggerElement,
	};

	const dialogProps =
		variant === 'alert'
			? ({ ...commonProps, variant: 'alert' } as AlertDialogProps)
			: ({ ...commonProps, variant, onCloseButtonAriaLabel: 'Close dialog' } as FocusDialogProps);

	return (
		<UnifiedDialog {...dialogProps}>
			<FootnoteProvider>
				<StyledDialogContent className={classNameContent}>
					{children}
					<FootnoteRenderer />
				</StyledDialogContent>
			</FootnoteProvider>
		</UnifiedDialog>
	);
};
